import React from 'react';
import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { FaCheckCircle, FaExclamationTriangle, FaTimesCircle } from 'react-icons/fa';

const Wrapper = styled.div<{ status: RightsEffectStatus }>`
  display: flex;
  justify-items: center;
  gap: 4px;
  font-size: 15px;
  color: ${(prop) => getColor(prop.status)};
  float: left;
  margin: 2px 4px;
  line-height: 1.5em;
`;

export enum RightsEffectStatus {
  Effective = '權利有效',
  InEffective = '權利無效',
  None = '權利已過專用期限',
}

const getIcon = (status: RightsEffectStatus) => {
  switch (status) {
    case '權利有效':
      return <FaCheckCircle />;
    case '權利無效':
      return <FaTimesCircle />;
    case '權利已過專用期限':
      return <FaExclamationTriangle />;
  }
};

const getColor = (status: RightsEffectStatus) => {
  switch (status) {
    case '權利有效':
      return colors.primaryGreen_700;
    case '權利無效':
      return colors.notice_error;
    case '權利已過專用期限':
      return colors.notice_orange;
  }
};

interface IProps {
  status: RightsEffectStatus;
  content?: string;
}

/**
 * 權利狀態標籤。
 */
const RightsEffectiveTag: React.FC<IProps> = ({ status, content }) => {
  return (
    <Wrapper status={status}>
      <span>{getIcon(status)}</span>
      {status}
      {status === RightsEffectStatus.InEffective && content && '（' + content + '）'}
    </Wrapper>
  );
};

export default RightsEffectiveTag;
